// extracted by mini-css-extract-plugin
var _1 = "ProfileContactsWidgetCreateFormContent-modulebuttonSelect__uRxM8";
var _2 = "ProfileContactsWidgetCreateFormContent-modulewrapper__AQQCR ProfileContactsWidgetListCellEditFields-modulewrapper__XR4mF";
export { _1 as "buttonSelect", _2 as "wrapper" }
